/* eslint-disable no-use-before-define */
import { GDTApiErrors } from '@/types';
import { axiosErrorHandler, TEXTS, URLs } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

interface CamisetaDBDTO {
  /** Format: int32 */
  id?: number;
  cami?: string;
  escu?: string;
}
interface ResponseObtenerCamisetasOtros {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error (opcional)
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  camisetas?: CamisetaDBDTO[];
}

export const getTshirtAndShieldByIds = axiosErrorHandler(
  async (ids: number[]) => {
    const url = `${URLs.CAMISETA_ESCUDO_POR_ID}?ids=${ids}`;
    const response = await axiosGdt.get<
      ResponseObtenerCamisetasOtros | GDTApiErrors
    >(url);

    return response.data;
  },
  TEXTS.defaultError
);
